import { type UseFormReturn } from "react-hook-form";
import { z, type ZodIssue } from "zod";

export type serverActionResponse =
  | {
      success: true;
      data?: any;
    }
  | {
      success: false;
      formErrors: ZodIssue[];
    };

export function mapServerErrors({
  form,
  errors,
}: {
  form: UseFormReturn<any>;
  errors: ZodIssue[];
}) {
  //here we map the error to the form (react-hook-form - criteriaMode: "firstError")
  errors.reverse().forEach((issue: ZodIssue) => {
    form.setError(
      issue.path.join("."),
      { type: "@/utils", message: issue.message },
      {
        shouldFocus: true,
      }
    );
  });

  //
}
